import { render, staticRenderFns } from "./ComplianceBanner.vue?vue&type=template&id=0fac41de&"
import script from "./ComplianceBanner.vue?vue&type=script&lang=js&"
export * from "./ComplianceBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports